export default "__VITE_ASSET__c29e3b0b__"